import type { CatalogueStatus, StatusFilter } from '../types';

export interface StatusFields {
  divest?: boolean | null;
  deprecated_date?: string | null;
}

export function todayIsoDate(now: Date = new Date()): string {
  return now.toISOString().slice(0, 10);
}

export function catalogueStatus(row: StatusFields, now: Date = new Date()): CatalogueStatus {
  const deprecatedDate = row.deprecated_date?.slice(0, 10);
  if (deprecatedDate && deprecatedDate <= todayIsoDate(now)) {
    return 'deprecated';
  }
  if (row.divest) {
    return 'divested';
  }
  return 'active';
}

export function matchesStatusFilter(
  row: StatusFields,
  filter: StatusFilter,
  now: Date = new Date()
): boolean {
  if (filter === 'all') return true;
  if (filter === 'active') return catalogueStatus(row, now) !== 'deprecated';
  return catalogueStatus(row, now) === filter;
}

export function defaultListIncludes(row: StatusFields, now: Date = new Date()): boolean {
  return catalogueStatus(row, now) !== 'deprecated';
}

export function statusLabel(status: CatalogueStatus): string {
  if (status === 'divested') return 'Divested';
  if (status === 'deprecated') return 'Deprecated';
  return 'Active';
}
